export function crmSearchTypeSelectAndFields() {
  return {
    restrict: 'E',
    template: require('./crm-search-type-select-and-fields.directive.html'),
    scope: {
      companyId: '<',
      organizationId: '<',
      entry: '=',
      objectsDescriptions: '=',
      contactObjectName: '<'
    },
    controller: controller
  };
}

controller.$inject = ['$scope', '$stateParams', 'CrmStrategiesFactory'];
function controller($scope, $stateParams, CrmStrategiesFactory) {
  $scope.onSearchTypeUpdated = onSearchTypeUpdated;
  $scope.canChooseSearchType = CrmStrategiesFactory.getStrategy($stateParams.crmType).canChooseSearchType();
  if ($scope.entry.search_type === undefined) {
    $scope.entry.search_type = CrmStrategiesFactory.getStrategy($stateParams.crmType).defaultSearchType();
  }
  function onSearchTypeUpdated() {
    $scope.entry.search_group = '';
    $scope.entry.field_name = '';
    $scope.entry.field_type = '';
    $scope.entry.display_label = '';
  }
}
